<template>
  <div>
    <DashFilters @filter-changed="onFilterChanged" />
    <div v-if="chartData && chartData.length">
      <DxChart
        v-if="chartData && chartData.length"
        :data-source="chartData"
        :title="$t('reporting.management_board.sowed_stage_overview')"
        palette="Soft"
      >
        <DxExport :enabled="true" />
        <DxArgumentAxis argument-type="string" />
        <DxValueAxis>
          <DxTitle :text="$t('common.hectares')" />
        </DxValueAxis>
        <DxSeries
          value-field="unsowed_area"
          argument-field="crop"
          :name="$t('reporting.management_board.unsowed_area')"
          type="stackedBar"
          color="#90caf9"
        />
        <DxSeries
          value-field="sowed_area"
          argument-field="crop"
          :name="$t('reporting.management_board.sowed_area')"
          type="stackedBar"
          color="#43a047"
        />
        <DxLegend vertical-alignment="bottom" horizontal-alignment="center" />
        <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
      </DxChart>
    </div>
    <div v-else style="margin-bottom: 30px">
      <span style="font-style: italic; color: red; font-weight: bold; margin-left: 20px;">
        {{ $t('common.no_data_found') }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { DxChart, DxSeries, DxArgumentAxis, DxValueAxis, DxLegend, DxTooltip, DxTitle, DxExport } from "devextreme-vue/chart";
import { DxSelectBox } from "devextreme-vue/select-box";
import DashFilters from "./DashFilters.vue";

export default {
  name: "SowedStage",
  components: {
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxValueAxis,
    DxLegend,
    DxTooltip,
    DxTitle,
    DxSelectBox,
    DxExport,
    DashFilters,
  },
  data() {
    return {
      chartData: [],
    };
  },
  computed: {
    ...mapGetters({
      seasons: "seasons/seasons",
    }),
  },
  methods: {
    ...mapActions({
      getSowedSurfaceReport: "works-parcels/getSowedSurfaceReport",
    }),
    customizeTooltip(info) {
      // info.point.data contains the full data object for the bar
      const data = info.point.data;
      const total = data.sowed_area + data.unsowed_area;
      return {
        html: `
        <strong>${data.crop}</strong><br>
        Total area: <b>${total}</b> ha<br>
        ${this.$t("reporting.management_board.sowed_area")}: <b>${data.sowed_area}</b> ha<br>
        ${this.$t("reporting.management_board.unsowed_area")}: <b>${data.unsowed_area}</b> ha
      `,
      };
    },
    onFilterChanged(filters) {
      this.getSowedSurfaceReportData(filters);
    },
    getSowedSurfaceReportData(filters) {
      if (!filters.season_uuid) return;
      const params = {
        season_uuid: filters.season_uuid,
        department_uuids: filters.departments,
        group_uuids: filters.groups,
      };
      this.getSowedSurfaceReport(params).then((response) => {
        // Assuming response contains the crop rotation data

        this.chartData = []; // Update with actual data from response

        if (response && Array.isArray(response)) {
          this.chartData = response.map((item) => ({
            crop: item.culture_uuid && item.culture ? item.culture.name : this.$t("common.unknown"),
            sowed_area: parseFloat(parseFloat(item.net_surface_worked).toFixed(2)),
            unsowed_area: parseFloat((parseFloat(item.total_surface) - parseFloat(item.net_surface_worked)).toFixed(2)),
          }));
        }
      });
    },
  },
  mounted() {},
};
</script>
<style scoped></style>
